import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const GROUPS = [
  {
    h: "Product",
    links: [
      { to: "/", label: "Home" },
      { to: "/compare", label: "Domain price comparison" },
      { to: "/ai-finder", label: "AI Name Finder" },
      { to: "/premium-domains", label: "Premium domains" },
      { to: "/pricing", label: "Pricing — Free & Pro" },
      { to: "/blog", label: "Blog" },
    ],
  },
  {
    h: "Guides",
    links: [
      { to: "/cheap-domains", label: "Cheap domains" },
      { to: "/cheapest-domain-registration", label: "Cheapest domain registration" },
      { to: "/cheap-domain-and-hosting", label: "Cheap domain & hosting" },
      { to: "/cheap-domain-and-email", label: "Cheap domain & email" },
      { to: "/cheapest-com-domain", label: "Cheapest .com domain" },
      { to: "/domain-price-comparison", label: "Domain price comparison guide" },
      { to: "/buy-domain-cheap", label: "Buy domain cheap — 2026 guide" },
      { to: "/cheap-domain-provider", label: "Best cheap domain providers" },
      { to: "/cheap-domain-registrars", label: "Cheapest domain registrars ranked" },
      { to: "/how-to-transfer-domain", label: "How to transfer a domain" },
      { to: "/namecheap-vs-godaddy-vs-cloudflare", label: "Namecheap vs GoDaddy vs Cloudflare" },
      { to: "/whois-privacy-explained", label: "WHOIS privacy explained" },
      { to: "/renewal-traps-to-avoid", label: "Domain renewal traps to avoid" },
      { to: "/io-vs-com-vs-ai", label: ".io vs .com vs .ai" },
      { to: "/ai-domain-names-for-sale", label: "AI domain names for sale" },
      { to: "/expiring-domain-names", label: "Expiring domain names" },
      { to: "/saas-domains-for-sale", label: "SaaS domains for sale" },
      { to: "/startup-domains-for-sale", label: "Startup domains for sale" },
      { to: "/cheap-domain-names", label: "Cheap domain names — 2026 picks" },
      { to: "/best-ai-domains", label: "Best .ai domains" },
      { to: "/best-dot-ai-domains", label: "Why .ai is the new .com" },
      { to: "/startup-domain-names", label: "Startup naming playbook" },
      { to: "/hotel-tech-domains", label: "Hotel tech domain names" },
    ],
  },
  {
    h: "Company",
    links: [
      { to: "/about", label: "About Dompryce" },
      { to: "/contact", label: "Contact us" },
    ],
  },
  {
    h: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Service" },
      { to: "/cookies", label: "Cookie Policy" },
    ],
  },
];

export default function Sitemap() {
  return (
    <Layout>
      <Seo
        title="Sitemap — every page on Dompryce"
        description="Browse every page on Dompryce: product pages, naming and pricing guides, company info and legal documents."
        path="/sitemap"
      />
      <article className="mx-auto max-w-4xl py-8" data-testid="sitemap-page">
        <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400">Sitemap</div>
        <h1 className="mt-2 font-display text-4xl font-bold tracking-tight text-zinc-900 md:text-5xl">
          Every page, in one place.
        </h1>
        <p className="mt-3 max-w-2xl text-zinc-600">
          Looking for something specific? Here's a tidy index of everything Dompryce has to offer. If you'd rather an XML feed for crawlers, our{" "}
          <a href="/sitemap.xml" className="font-medium text-indigo-600 hover:text-indigo-500">sitemap.xml</a> is live too.
        </p>

        <div className="mt-12 grid gap-10 md:grid-cols-2">
          {GROUPS.map((g) => (
            <section key={g.h}>
              <h2 className="text-[10px] font-semibold uppercase tracking-[0.2em] text-zinc-400">{g.h}</h2>
              <ul className="mt-4 space-y-2.5">
                {g.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      data-testid={`sitemap-link-${l.to}`}
                      className="text-sm text-zinc-700 hover:text-indigo-700"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </article>
    </Layout>
  );
}
